"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableHeight = exports.useDebouncedEffect = void 0;
var react_1 = require("react");
var useDebouncedEffect = function (effect, deps, delay) {
    (0, react_1.useEffect)(function () {
        var handler = setTimeout(function () { return effect(); }, delay);
        return function () { return clearTimeout(handler); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, __spreadArray(__spreadArray([], (deps || []), true), [delay], false));
};
exports.useDebouncedEffect = useDebouncedEffect;
/**
 * The scrollbar takes some height and we have to consider it
 * when calculating the virtualized table height
 *
 * @returns number
 */
function getScrollbarHeight() {
    var scrollDiv = document.createElement('div');
    scrollDiv.setAttribute('style', 'width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;');
    document.body.appendChild(scrollDiv);
    var scrollbarHeight = scrollDiv.offsetHeight - scrollDiv.clientHeight;
    document.body.removeChild(scrollDiv);
    return scrollbarHeight;
}
function useTableHeight(_a) {
    var rowsToShow = _a.rowsToShow, rowHeight = _a.rowHeight, headerHeight = _a.headerHeight, footerHeight = _a.footerHeight;
    return (0, react_1.useMemo)(function () {
        var scrollbarHeight = getScrollbarHeight();
        return rowsToShow * rowHeight + headerHeight + footerHeight + scrollbarHeight;
    }, [rowsToShow, rowHeight, headerHeight, footerHeight]);
}
exports.useTableHeight = useTableHeight;
